import api from './api';

export interface ExerciseContainer {
  id: number;
  title: string;
  parent?: number | null;
  created_by?: number;
  created_at?: string;
  updated_at?: string;
  order: number;
  children_count?: number;
  exercises_count?: number;
}

class ExerciseContainerService {
  async getContainers(parentId?: number | null): Promise<ExerciseContainer[]> {
    const params = parentId !== undefined ? { parent: parentId } : {};
    const response = await api.get('/exercise-containers/', { params });
    return response.data.results || response.data || [];
  }

  async getContainer(id: number): Promise<ExerciseContainer> {
    const response = await api.get(`/exercise-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(containerId: number): Promise<{containers: ExerciseContainer[], exercises: any[]}> {
    const response = await api.get(`/exercise-containers/${containerId}/contents/`);
    return response.data;
  }

  async getRootContents(): Promise<{containers: ExerciseContainer[], exercises: any[]}> {
    // Get root containers
    const containersResponse = await api.get('/exercise-containers/', { params: { parent: 'null' } });

    // Get root exercises
    const exercisesResponse = await api.get('/exercises/', { params: { container: 'null' } });

    return {
      containers: containersResponse.data.results || containersResponse.data || [],
      exercises: exercisesResponse.data.results || exercisesResponse.data || []
    };
  }

  async createContainer(data: Partial<ExerciseContainer>): Promise<ExerciseContainer> {
    const response = await api.post('/exercise-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<ExerciseContainer>): Promise<ExerciseContainer> {
    const response = await api.patch(`/exercise-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/exercise-containers/${id}/`);
  }

  async reorderContainers(items: Array<{id: number, order: number, parent?: number | null}>): Promise<void> {
    await api.post('/exercise-containers/reorder/', { items });
  }
}

const exerciseContainerService = new ExerciseContainerService();
export default exerciseContainerService;